import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ExtraDataApiModel, MobileGuestApiModel } from '@rocksoft/inroom-sdk';
import { RoomConfiguration } from '../room-configuration-store/room-configuration.reducer';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-guest-info-ui',
  templateUrl: './guest-info.component.html',
  styleUrls: ['./guest-info.component.scss'],
  imports: [ReactiveFormsModule],
})
export class GuestInfoComponent {
  readonly guest = input.required<MobileGuestApiModel>();
  readonly extraData = input.required<ExtraDataApiModel>();
  readonly roomConfiguration = input.required<RoomConfiguration>();

  readonly extraDataChange = output<ExtraDataApiModel>();
  readonly roomConfigurationChange = output<RoomConfiguration>();

  readonly extraDataForm = new UntypedFormGroup({
    airplayUsername: new UntypedFormControl(''),
    airplayPassword: new UntypedFormControl(''),
  });

  readonly tokenForm = new UntypedFormGroup({
    token: new UntypedFormControl(''),
  });

  constructor() {
    effect(() => {
      const extraData = this.extraData();
      if (extraData) {
        this.extraDataForm.patchValue({
          airplayUsername: extraData.AirplayUsername,
          airplayPassword: extraData.AirplayPassword,
        });
      } else {
        this.extraDataForm.setValue({
          airplayUsername: '',
          airplayPassword: '',
        });
      }
    });

    effect(() => {
      const roomConfiguration = this.roomConfiguration();
      if (roomConfiguration) {
        this.tokenForm.patchValue({
          token: roomConfiguration.token,
        });
      } else {
        this.tokenForm.setValue({
          token: '',
        });
      }
    });
  }

  onSubmit() {
    this.extraDataChange.emit({
      AirplayUsername: this.extraDataForm.get('airplayUsername')?.value,
      AirplayPassword: this.extraDataForm.get('airplayPassword')?.value,
    });
  }

  onSubmitToken() {
    this.roomConfigurationChange.emit({
      hotelCode: this.roomConfiguration().hotelCode,
      unitCode: this.roomConfiguration().unitCode,
      token: this.tokenForm.get('token')?.value,
    });
  }
}
